import * as React from 'react';
import PropTypes from 'prop-types';
import { ZendeskChat } from './ZendeskChat.js';

/**
 * Copyright 2023, IntraLinks, Inc, All rights reserved.
 */
function ZendeskChatContainer(_ref) {
  var integrationId = _ref.integrationId,
    externalId = _ref.externalId,
    jwt = _ref.jwt;
  ZendeskChat({
    integrationId: integrationId,
    externalId: externalId,
    jwt: jwt
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "ZendeskChat Loaded"));
}
ZendeskChatContainer.propTypes = {
  integrationId: PropTypes.string,
  externalId: PropTypes.string,
  jwt: PropTypes.string
};

export { ZendeskChatContainer };
